import { EDITOR_MODE, useEditorMode } from "@pathwright/blocks-engine"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import React from "react"
import Slick from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import ImageEdit from "../../../shared/ImageEdit"
import { StyledCarousel } from "../ui"

const Arrow = (props) => {
  const { className, onClick, style, direction } = props

  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        ...style,
        zIndex: 100,
        width: 80,
        height: 80
      }}
    >
      <Pathicon icon={`chevron-${direction}`} />
    </div>
  )
}

export const SlickCarousel = (props) => {
  const { onChange, data } = props

  const { mode } = useEditorMode()

  const sliderRef = React.useRef(null)
  const slider = sliderRef.curret

  React.useEffect(() => {
    if (!slider) return

    // Force a window resize event after each image loads
    // in order to properly size the carousel
    if (slider.innerSlider && slider.innerSlider.list) {
      const images = slider.innerSlider.list.querySelectorAll("img")
      if (images && images.length) {
        images.forEach((img) => {
          img.addEventListener("load", () => {
            window.dispatchEvent(new Event("resize"), { bubbles: true })
          })
        })
      } else {
        window.dispatchEvent(new Event("resize"), { bubbles: true })
      }
    }

    // Slick is having trouble with the height of the carousel
    const timer = setTimeout(() => {
      window.dispatchEvent(new Event("resize"), { bubbles: true })
    }, 700)

    return () => clearTimeout(timer)
  }, [])

  const handleChangeCaption = (imageIndex, caption) => {
    if (mode !== EDITOR_MODE.EDIT || !onChange || !data.images[imageIndex])
      return

    const nextImages = [...data.images]
    nextImages[imageIndex] = {
      ...nextImages[imageIndex],
      caption
    }

    onChange({ images: nextImages })
  }

  const settings = {
    // dots: true,
    adaptiveHeight: true,
    nextArrow: <Arrow direction="right" />,
    prevArrow: <Arrow direction="left" />
  }

  return (
    <Slick {...settings} ref={sliderRef}>
      {data.images.map((x, i) => (
        <div key={i} style={{ backgroundColor: "white" }}>
          <ImageEdit
            image={x.src}
            captionBounds={`.slick-slider`}
            readOnly
            captionEnabled
            caption={x.caption}
            captionEditOnly={mode === EDITOR_MODE.EDIT}
            onChangeCaption={(caption) => handleChangeCaption(i, caption)}
          />
        </div>
      ))}
    </Slick>
  )
}

const Carousel = (props) => {
  const { preview, data } = props

  return (
    <StyledCarousel className="swiper-no-swiping">
      {preview ? (
        <ImageEdit
          image={data.images[0].src}
          readOnly
          captionEnabled
          caption={data.images[0].caption}
        />
      ) : (
        <SlickCarousel {...props} />
      )}
    </StyledCarousel>
  )
}

export default Carousel
